<template>
  <div>
    <v-layout>
      <async-data :request-state="requestState">
        <div v-if="caseDetails"> <!--todo: use scoped slot -->
          <h1 v-if="caseDetails.dpId">
            Case <a :href="buildDPCaseUrl(caseDetails.dpId)" @click.stop='' target="_blank">{{caseDetails.title}}</a>
            <modal-json-view :json-data="caseDetails"/>
          </h1>
          <h1 v-else>
            Case {{caseDetails.title}}
            <modal-json-view :json-data="caseDetails"/>
          </h1>

          <restart-case-to-work-form :case-id="caseId"/>

          <case-info :case-id="$route.params.caseId"/>
        </div>
      </async-data>
    </v-layout>

    <v-layout>
      <router-view/>
    </v-layout>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import AsyncData from "../../components/Ui/AsyncData";
  import {RequestState} from '../../requestState';
  import NoEmpty from '../../components/Filters/NoEmpty'
  import CaseInfo from '../../components/case/CaseInfo'
  import ModalJsonView from "../../components/Ui/ModalJsonView";
  import RestartCaseToWorkForm from "../../components/case/RestartCaseToWorkForm";

  export default {
    name: 'case-page',
    components: {
      AsyncData,
      CaseInfo,
      ModalJsonView,
      RestartCaseToWorkForm
    },
    filters: {
      NoEmpty
    },
    data() {
      return {}
    },
    computed: {
      caseId() {
        return this.$route.params.caseId
      },
      caseInfo() {
        return this.$store.getters.getCaseInfoById(this.caseId)
      },
      requestState() {
        if (!this.caseInfo) {
          return RequestState.NotPerformed
        }

        return this.caseInfo.requestState
      },
      caseDetails() {
        if (!this.caseInfo) {
          return null
        }

        return this.caseInfo.response || null
      },
      fetchDPUrl () {
        return this.$store.state.dpURL
      }
    },
    mounted() {
      this.fetchCaseByIdIfRequired(this.$route.params.caseId)
    },
    methods: {
      ...mapActions({
        fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired'
      }),
      buildDPCaseUrl(dpCaseId) {
        return `${fetchDPUrl}cases/${dpCaseId}`
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/cases/CasePage.vue